export default __webpack_public_path__ + "static/media/logofooter.4d195066.svg";